import _implicitStylesheets from "./headerWrapper.css";
import _implicitScopedStylesheets from "./headerWrapper.scoped.css?scoped=true";
import _aceHeaderV2 from "ace/headerV2";
import _aceHeader from "ace/header";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  key: 1
};
const stc1 = {
  key: 2
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, fr: api_fragment} = $api;
  return [$cmp.useUnifiedHeaderV2 ? api_fragment(0, [api_custom_element("ace-header-v2", _aceHeaderV2, stc0)], 0) : api_fragment(0, [api_custom_element("ace-header", _aceHeader, stc1)], 0)];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7mrt1pk1pea";
tmpl.legacyStylesheetToken = "undefined-_headerWrapper";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
